import styled from 'react-emotion';

export const Seating = styled.div`
	display: block;
	height: 150px;
	margin: 1rem auto 2rem;
	position: relative;
	width: 450px;

	@media (max-width: 500px) {
		height: 160px;
		width: 100%;
	}

	@media (max-width: 375px) {
		height: 130px;
	}
`;

export const Seat = styled.span`
	border: 1px solid #fff;
	display: inline-block;
	height: 1.5rem;
	margin-right: 0.25rem;
	vertical-align: top;
	width: 1.5rem;
`;

export const Seats = styled.div`
	position: absolute;
	transform: rotate(-90deg) scaleX(-1);
	transform-origin: 0 0;
	width: 190px;

	@media (max-width: 500px) {
		width: 160px;
	}

	@media (max-width: 374px) {
		width: 130px;
	}

	span {
		float: left;
		margin: 2px;

		@media (max-width: 500px) {
			height: 1rem;
			width: 1rem;
		}

		@media (max-width: 374px) {
			height: 0.75rem;
			width: 0.75rem;
		}

		&:nth-child(6),
		&:nth-child(11),
		&:nth-child(16),
		&:nth-child(21),
		&:nth-child(26),
		&:nth-child(31),
		&:nth-child(36),
		&:nth-child(41),
		&:nth-child(46),
		&:nth-child(51),
		&:nth-child(56),
		&:nth-child(61),
		&:nth-child(66),
		&:nth-child(71) {
			clear: left;
		}
	}
`;

export const Mandates = styled.div`
	margin-bottom: 1.5rem;
`;
